import React from 'react';
import { Section, SectionHeading, Reveal } from './ui/Section';

/**
 * 会社情報は docs/company-info.md を正とする。
 * 設立日は登記どおり 2022年5月10日（旧サイトの「2022年3月」は誤り）。
 */
const PROFILE: Array<{ label: string; value: React.ReactNode }> = [
  { label: '会社名', value: 'オーアーク株式会社' },
  { label: '英文社名', value: 'MYOAKU Co., Ltd.' },
  { label: '代表取締役', value: '徐 科（XU KE）' },
  { label: '設立', value: '2022年5月10日' },
  {
    label: '所在地',
    value: (
      <>
        〒132-0013
        <br />
        東京都江戸川区江戸川2丁目30-6 小倉荘201号室
      </>
    ),
  },
  {
    label: '事業内容',
    value: (
      <>
        システム開発・コンサルティング
        <br />
        IT導入支援
        <br />
        自社プロダクト開発
      </>
    ),
  },
];

const VALUES = [
  {
    title: '顧客第一主義',
    body: 'お客様の成功を私たちの成功と考え、最高のサービスを提供します',
  },
  {
    title: 'イノベーション',
    body: '最新のAI技術を活用し、会計業務の革新を推進します',
  },
  {
    title: '社会貢献',
    body: '中小企業の発展を支援し、日本経済の活性化に貢献します',
  },
];

const Company: React.FC = () => (
  <Section id="company" tone="muted">
    <SectionHeading eyebrow="Company" title="会社概要" lead="私たちについて" />

    <div className="mt-14 grid gap-8 lg:grid-cols-[1.1fr_1fr]">
      {/* 企業情報テーブル */}
      <Reveal>
        <div className="card overflow-hidden">
          <h3 className="border-b border-line bg-surface-muted px-8 py-5 font-bold text-ink-900">
            企業情報
          </h3>
          <dl className="px-8 py-2">
            {PROFILE.map((row) => (
              <div
                key={row.label}
                className="flex flex-col gap-1 border-b border-line py-4 last:border-0 sm:flex-row sm:gap-8"
              >
                <dt className="shrink-0 text-small font-bold text-body-soft sm:w-28">
                  {row.label}
                </dt>
                <dd className="text-small leading-relaxed text-ink-900">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </Reveal>

      {/* ミッション・ビジョン */}
      <Reveal delay={0.12}>
        <div className="flex h-full flex-col gap-6">
          <div className="card card-pad flex-1">
            <p className="text-eyebrow uppercase num text-brand-600">Mission</p>
            <h3 className="mt-3 text-h3 text-ink-900">ミッション</h3>
            <p className="mt-4 leading-relaxed text-body-soft">
              クラウドに依存しない独自のAIシステムで、データの安全性と低コストを両立した会計ソリューションを提供する
            </p>
          </div>
          <div className="card card-pad flex-1 bg-ink-900">
            <p className="text-eyebrow uppercase num text-brand-300">Vision</p>
            <h3 className="mt-3 text-h3 text-white">ビジョン</h3>
            <p className="mt-4 leading-relaxed text-ink-100">
              企業規模に関わらず、一目で経営状況が把握できる。そんな当たり前の未来を創る
            </p>
          </div>
        </div>
      </Reveal>
    </div>

    {/* 企業理念 */}
    <div className="mt-16">
      <Reveal>
        <h3 className="text-center text-h3 text-ink-900">企業理念</h3>
      </Reveal>
      <div className="mt-10 grid gap-6 sm:grid-cols-3">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.1}>
            <div className="border-t-2 border-brand-500 pt-6">
              <h4 className="font-bold text-ink-900">{v.title}</h4>
              <p className="mt-3 text-small leading-relaxed text-body-soft">{v.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </Section>
);

export default Company;
